var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 197.9,
    height: 91.3,
    viewBox: "0 0 197.9 91.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 197.9,
    height: 91.3,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0066f5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5-25.9q8.7,0,8.7,6.9,0,7.1-8.7,7.1H49.3v3.4q0,4.5-2.5,6.8A9.223,9.223,0,0,1,40.3.6a9.041,9.041,0,0,1-6.45-2.3Q31.4-4,31.4-8.5v-3.4H9.1a7.507,7.507,0,0,1-5.7-2.2,7.652,7.652,0,0,1-2.1-5.5,11.2,11.2,0,0,1,2.2-6.6L32.1-67a9.208,9.208,0,0,1,3.55-3.05A10.026,10.026,0,0,1,40.1-71.1a9.446,9.446,0,0,1,6.5,2.4A8.5,8.5,0,0,1,49.3-62v36.1Zm-20.1,0V-43.2l-12,17.3ZM90,.9Q76.9.9,70-8.4T63.1-35.3q0-17.5,6.9-26.8t20-9.3q13,0,19.95,9.3t6.95,26.8q0,17.6-6.9,26.9T90,.9ZM90-13q4.8,0,6.9-5.2T99-35.3q0-11.8-2.1-17T90-57.5q-4.8,0-6.9,5.15T81-35.3q0,11.9,2.1,17.1T90-13Zm81.5-12.9q8.7,0,8.7,6.9,0,7.1-8.7,7.1h-2.2v3.4q0,4.5-2.5,6.8A9.223,9.223,0,0,1,160.3.6a9.041,9.041,0,0,1-6.45-2.3Q151.4-4,151.4-8.5v-3.4H129.1a7.507,7.507,0,0,1-5.7-2.2,7.652,7.652,0,0,1-2.1-5.5,11.2,11.2,0,0,1,2.2-6.6L152.1-67a9.208,9.208,0,0,1,3.55-3.05,10.026,10.026,0,0,1,4.45-1.05,9.446,9.446,0,0,1,6.5,2.4,8.5,8.5,0,0,1,2.7,6.7v36.1Zm-20.1,0V-43.2l-12,17.3Z",
    transform: "translate(8.2 77.9)",
    fill: "none",
    stroke: "#0066f5",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.8bbb34c871c4712298a25e20c4dc75c7.svg";
export { ForwardRef as ReactComponent };